import { __rest } from "tslib";
import * as React from 'react';
import { Route, Switch } from 'react-router';
import { useGlobalState } from '../hooks';
/**
 * The component for defining the exclusive routes to be used.
 */
export const PiralRoutes = (_a) => {
    var { NotFound } = _a, props = __rest(_a, ["NotFound"]);
    const routes = useGlobalState((s) => s.routes);
    const pages = useGlobalState((s) => s.registry.pages);
    return (React.createElement(Switch, Object.assign({}, props),
        Object.keys(routes).map((url) => (React.createElement(Route, { exact: true, key: url, path: url, component: routes[url] }))),
        Object.keys(pages).map((url) => (React.createElement(Route, { exact: true, key: url, path: url, component: pages[url].component }))),
        React.createElement(Route, { component: NotFound })));
};
PiralRoutes.displayName = 'Routes';
//# sourceMappingURL=PiralRoutes.js.map